export default commomImport => [{
  path: `image-manager`,
  name: 'ImageManager',
  meta: {
    title: 'store.imageManager'
  },
  //  全部订单
  component: commomImport('store-manager/image-manager')
}];
